import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import {CgDetailsLess} from "react-icons/cg"
import { Link } from "react-router-dom";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img className="h-50 " variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <div className="d-flex flex-column  flex-xl-row justify-content-between">
        <Button variant="primary" href={props.ghLink} target="_blank">
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>   
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
          <Link className="btn btn-primary" to={`/projects/${props.id}`}> <CgDetailsLess/>  Details</Link>
        </div>
       
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
